import { Component, OnInit} from '@angular/core';

import { StripeService, Elements, Element as StripeElement, ElementsOptions } from 'ngx-stripe';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import {StripePaymentService} from '../../../../services/stripe-payment.service';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-stripe-payment',
  templateUrl: 'stripe-payment.component.html',
  styleUrls: ['stripe-payment.component.css']
})
export class StripePaymentComponent implements OnInit {
  elements: Elements;
  card: StripeElement;
  name: string;
  email: String;
  // optional parameters
  elementsOptions: ElementsOptions = {
    locale: 'en'
  };


  constructor(
    private stripeService: StripeService,
    private stripePaymentService: StripePaymentService,
    public  shoppingCartService: ShoppingCartService,
    private router: Router,
    private cookieService: CookieService,
    private spinner: NgxSpinnerService) {}

  ngOnInit() {

    this.stripeService.elements(this.elementsOptions)
      .subscribe(elements => {
        this.elements = elements;
        // Only mount the element the first time
        if (!this.card) {
          this.card = this.elements.create('card', {
            style: {
              base: {
                iconColor: '#666EE8',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                  color: '#CFD7E0'
                }
              }
            }
          });
          this.card.mount('#card-element');
        }
      });
  }

  pay() {
    this.stripeService
      .createToken(this.card, { name: this.name })
      .subscribe(result => {
        this.spinner.show();
        if (result.token) {
          this.stripePaymentService.sendStripePaymentRequest(this.shoppingCartService.basket,
            result.token.id).subscribe(
            (response) => {
              this.spinner.hide();
              // console.log(response.statusText);
              this.router.navigate(['/confirmation'])
                .then(() => {
                  this.cookieService.delete('basket');
                  this.shoppingCartService.cleanUpShoppingCart();
                });
            },
            (error) => {
              console.error(error);
              this.spinner.hide();
              // noinspection JSIgnoredPromiseFromCall
              this.router.navigate(['/error']);
            });
        } else if (result.error) {
          // Error creating the token
          console.error(result.error.message);
          this.spinner.hide();
          // noinspection JSIgnoredPromiseFromCall
          this.router.navigate(['/error']);

        }
      });
  }

  dancerSelected(dancerId: any) {
    const dancer = this.shoppingCartService.getDancer(dancerId);
    if (dancer) {
      // console.log(`${dancer.firstName} ${dancer.lastName}`);
      this.name = `${dancer.firstName} ${dancer.lastName}`;
      this.email = String(dancer.email);
    } else {
      this.name = '';
      this.email = '';
    }
  }
}
